// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__T2ow0","resendInfoText":"OnGoingPaymentBox_resendInfoText__76FO7"};